module.exports = "https://static.wanderu.com/ui-react/_next/static/media/kayak-logo-small.9b6e6eab.svg";